import registrationContractSignDictionary from '@features/registration/contract-sign/i18n/ru/contract-sign.dic.json';

export const registrationContractSign = {
  REGISTRATION_CONTRACT_SIGN: registrationContractSignDictionary,
};

export const registrationContractSignNamespaces = Object.keys(
  registrationContractSign
);
